import React, { useState } from "react";
import { FaFilter, FaTimes, FaChevronDown } from "react-icons/fa";

import styles from "./CarFilter.module.css";

const CarFilter = ({ onApply, onCancel, resultCount = 0 }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [hasAppliedFilter, setHasAppliedFilter] = useState(false);

    const [filters, setFilters] = useState({
        search: "",
        manufacturer: "",
        productYear: "",
    });

    const handleChange = (event) => {
        const { name, value } = event.target;

        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleToggle = () => {
        setIsOpen((prev) => !prev);
    };

    const handleApply = () => {
        onApply(filters);
        setHasAppliedFilter(true);
        setIsOpen(false);
    };

    const handleCancel = () => {
        const emptyFilters = {
            search: "",
            manufacturer: "",
            productYear: "",
        };

        setFilters(emptyFilters);
        onCancel(emptyFilters);

        setHasAppliedFilter(false);
        setIsOpen(false);
    };

    return (
        <div className={styles.filterBox} dir="rtl">
            <button
                type="button"
                className={styles.filterHeader}
                onClick={handleToggle}
                aria-expanded={isOpen}
            >
                <div className={styles.filterTitle}>
                    <FaFilter />
                    <span>فیلتر خودروها</span>

                    {hasAppliedFilter && (
                        <span className={styles.badge}>
                            {resultCount}
                        </span>
                    )}
                </div>

                <FaChevronDown
                    className={`${styles.chevron} ${
                        isOpen ? styles.chevronOpen : ""
                    }`}
                />
            </button>

            <div
                className={styles.collapseWrapper}
                data-open={isOpen}
            >
                <div className={styles.collapseInner}>
                    <div className={styles.fields}>
                        <div className={styles.field}>
                            <label htmlFor="car-search">
                                جستجوی خودرو
                            </label>

                            <input
                                id="car-search"
                                type="text"
                                name="search"
                                value={filters.search}
                                onChange={handleChange}
                                placeholder="نام خودرو..."
                            />
                        </div>

                        <div className={styles.field}>
                            <label htmlFor="car-manufacturer">
                                شرکت سازنده
                            </label>

                            <input
                                id="car-manufacturer"
                                type="text"
                                name="manufacturer"
                                value={filters.manufacturer}
                                onChange={handleChange}
                                placeholder="مثلاً ایران خودرو"
                            />
                        </div>

                        <div className={styles.field}>
                            <label htmlFor="car-year">
                                سال ساخت
                            </label>

                            <input
                                id="car-year"
                                type="number"
                                name="productYear"
                                value={filters.productYear}
                                onChange={handleChange}
                                placeholder="مثلاً 1402"
                            />
                        </div>
                    </div>

                    <div className={styles.actions}>
                        <button
                            type="button"
                            className={styles.applyButton}
                            onClick={handleApply}
                        >
                            <FaFilter />
                            مشاهده فیلتر
                        </button>

                        <button
                            type="button"
                            className={styles.cancelButton}
                            onClick={handleCancel}
                        >
                            <FaTimes />
                            پاک کردن فیلتر
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CarFilter;